export default {
  label: 'Account sections',
  account: 'Account',
  dashboard: 'Overview',
  orders: 'Orders',
  wishlist: 'Wishlist',
  billing: 'Billing',
  settings: 'Settings',
};
